import React, { useState, useEffect } from 'react'

import { detectBrowserSupport } from '../../utils/browserSupport'

import BrowserSupportModal from './BrowserSupportModal'

import { Button } from '@/components/ui/base'
import { Alert } from '@/components/ui/base'

export const UnsupportedBrowserBanner: React.FC = () => {
  const [browserSupport, setBrowserSupport] = useState<ReturnType<typeof detectBrowserSupport> | null>(null)
  const [showModal, setShowModal] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    const support = detectBrowserSupport()
    setBrowserSupport(support)

    // Check if user has previously dismissed the warning
    const dismissedKey = `browser-warning-dismissed-${support.browserName}-${support.browserVersion}`
    const wasDismissed = localStorage.getItem(dismissedKey) === 'true'
    setDismissed(wasDismissed)
  }, [])

  const handleDismiss = () => {
    if (browserSupport) {
      const dismissedKey = `browser-warning-dismissed-${browserSupport.browserName}-${browserSupport.browserVersion}`
      localStorage.setItem(dismissedKey, 'true')
      setDismissed(true)
    }
  }

  const handleLearnMore = () => {
    setShowModal(true)
  }

  if (!browserSupport || browserSupport.isSupported || dismissed) {
    return null
  }

  const getIssueDescription = () => {
    const issues = []
    if (!browserSupport.webp) issues.push('images may not display correctly')
    if (!browserSupport.modernCSS) issues.push('layout may appear broken')
    return issues.join(' and ')
  }

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          padding: '12px',
          backgroundColor: '#fff2f0',
          borderBottom: '1px solid #ffccc7',
        }}
      >
        <Alert
          type="warning"
          statusIconAriaLabel="Browser compatibility warning"
          dismissible
          onDismiss={handleDismiss}
          action={
            <Button variant="link" onClick={handleLearnMore}>
              Learn more
            </Button>
          }
        >
          <strong>Browser Compatibility Notice:</strong> You're using {browserSupport.browserName}{' '}
          {browserSupport.browserVersion}, which may not fully support our modern features. For the best experience,{' '}
          {getIssueDescription()}. Consider updating to a newer browser version.
        </Alert>
      </div>

      <BrowserSupportModal visible={showModal} onDismiss={() => setShowModal(false)} />
    </>
  )
}

export default UnsupportedBrowserBanner
